import type { ReactNode } from "react";

import { useEntitlements } from "./useEntitlements";

/**
 * Renders children only when the active workspace's plan includes the
 * feature. Optional fallback for upgrade prompts. UI gating only, the
 * server enforces entitlements independently.
 */
export const FeatureGate = ({
  feature,
  children,
  fallback = null,
}: {
  feature: string;
  children: ReactNode;
  fallback?: ReactNode;
}) => {
  const { hasFeature, isPending } = useEntitlements();
  if (isPending) return null;
  return hasFeature(feature) ? <>{children}</> : <>{fallback}</>;
};
